import React, { useEffect, useState } from "react";

const Navdata = () => {
    //state data
    const [isEcommerce, setIsEcommerce] = useState(false);
    const [isOrder, setIsOrder] = useState(false);
    const [isSellers, setIsSellers] = useState(false);
    const [isInvoice, setIsInvoice] = useState(false);
    const [isShipping, setIsShipping] = useState(false);
    const [isLocalization, setIsLocalization] = useState(false);
    const [isAuth, setIsAuth] = useState(false);
    const [isMultiLevel, setIsMultiLevel] = useState(false);

    // Multi Level
    const [isLevel1, setIsLevel1] = useState(false);
    const [isLevel2, setIsLevel2] = useState(false);

    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("subitems")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems: any = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                // var id: any = item.getAttribute("subitems");
                // if (document.getElementById(id)){
                //     document.getElementById(id).classList.remove("show");
                // }
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');
        if (iscurrentState !== 'Ecommerce') {
            setIsEcommerce(false);
        }
        if (iscurrentState !== 'Orders') {
            setIsOrder(false);
        }
        if (iscurrentState !== 'Sellers') {
            setIsSellers(false);
        }
        if (iscurrentState !== 'Invoice') {
            setIsInvoice(false);
        }
        if (iscurrentState !== 'Shipping') {
            setIsShipping(false);
        }
        if (iscurrentState !== 'Localization') {
            setIsLocalization(false);
        }
        if (iscurrentState !== 'Auth') {
            setIsAuth(false);
        }
    }, [
        iscurrentState,
        isEcommerce,
        isOrder,
        isInvoice,
        isShipping,
        isLocalization,
        isAuth,
        isMultiLevel
    ]);

    const menuItems: any = [
        {
            label: "Menu",
            isHeader: true,
        },
        {
            id: "dashboard",
            label: "Dashboard",
            icon: "bi bi-speedometer2",
            link: "/dashboard",
        },
        {
            id: "products",
            label: "Parts",
            icon: "bi bi-box-seam",
            link: "/products-list",
        },
        {
            id: "orders",
            label: "Orders",
            icon: "bi bi-cart4",
            link: "/orders-list-view",
        },
        {
            id: "seller",
            label: "Sellers",
            icon: "bi bi-binoculars",
            link: "/sellers-list-view",
        },
        {
            id: "userslist",
            label: "Buyers List",
            icon: "bi bi-person-bounding-box",
            link: "/users-list",
        },
        {
            id: "statistics",
            label: "Statistics",
            icon: "bi bi-pie-chart",
            link: "/statistics",
        },
        {
            id: "categories",
            label: "Categories",
            icon: "bi bi-grid",
            link: "/categories",
        },
        {
            id: "contentManagement",
            label: "Content Management",
            icon: "bi bi-file-text",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsAuth(!isAuth);
                setIscurrentState('Auth');
                updateIconSidebar(e);
            },
            stateVariables: isAuth,
            subItems: [
                {
                    id: "dashboardManagement",
                    label: "Dashboard",
                    link: "/dashboardManagement",
                    parentId: "content",
                },
                {
                    id: "aboutUsManagement",
                    label: "About Us",
                    link: "/aboutUsManagement",
                    parentId: "content",
                },
                {
                    id: "Guide Management",
                    label: "Guide",
                    link: "/guideManagement",
                    parentId: "content",
                },
            ],
        },
        {
            id: "accounts",
            label: "Accounts",
            icon: "bi bi-person-circle",
            link: "/#",
            click: function (e: any) {
                e.preventDefault();
                setIsAuth(!isAuth);
                setIscurrentState('Auth');
                updateIconSidebar(e);
            },
            stateVariables: isAuth,
            subItems: [
                {
                    id: "myAccount",
                    label: "My Accounts",
                    link: "/account",
                    parentId: "account",
                },
                {
                    id: "settings",
                    label: "Settings",
                    link: "/settings",
                    parentId: "account",
                },
            ],
        },
    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;